import { InspectionCompany } from 'api';
import type { I18nTranslateFunction } from 'i18n';
import { Chip, type GridColDef } from 'ui';

type Translate = I18nTranslateFunction<string>;

const formatInspectors = (
  value:
    | {
        id: number;
        name: string;
        is_active?: boolean;
      }[]
    | null
) => {
  return value?.map((valueItem) => valueItem.name).join(', ') || null;
};

export const getColumns = (t: Translate): GridColDef<InspectionCompany>[] => [
  {
    field: 'name',
    flex: 1,
    headerName: t('inspectionCompany.fields.name'),
  },
  {
    field: 'is_active',
    headerName: t('inspectionCompany.fields.status'),
    renderCell: (params) => {
      return (
        <Chip
          color={params.value ? 'success' : 'error'}
          variant="outlined"
          label={params.value ? t('inspectionCompany.status.active') : t('inspectionCompany.status.inactive')}
        />
      );
    },
  },
  {
    field: 'inspectors',
    flex: 2,
    headerName: t('inspectionCompany.fields.inspectors'),
    sortable: false,
    valueFormatter: (value) => formatInspectors(value) || t('inspectionCompany.values.notAvailable'),
  },
];
